module.exports = __webpack_public_path__ + "img/person.889c806c.svg";